import {
    GET_LIST_MEDIA_LIBRARY,
    REMOVE_MEDIA_LIBRARY
} from '../actions/types';

const INIT_STATE = {
    media_list: [],
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_MEDIA_LIBRARY:
            return {
                ...state,
                media_list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page)
                }
            };
        case REMOVE_MEDIA_LIBRARY: {
            let temp = state.media_list.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, media_list: temp }
        }
        default:
            return { ...state }
    }
};
